class ShippingBar extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.shippingProgress = this.querySelector('.shipping-bar__progress');
    this.shippingIndicator = this.querySelector('.shipping-bar__indicator');

    this.currentValue = this.shippingIndicator?.getAttribute('data-current-value');
    this.goalValue = this.shippingIndicator?.getAttribute('data-goal-value');

    if(this.currentValue && this.goalValue) {
      requestAnimationFrame(() => {
        this.updateProgress(this.currentValue, this.goalValue);
      });
    }
  }

  async updateProgress(currentValue, goalValue) {
    const existSubscription = await this.checkSubscription();
    const percentage = existSubscription ? 100 : Math.min((currentValue / goalValue) * 100, 100);
    this.shippingProgress.style.width = `${ percentage }%`;

    const gradientOpacity = percentage / 100;
    this.shippingProgress.style.background = `linear-gradient(to right, rgba(255, 106, 106, ${ gradientOpacity }), rgba(255, 179, 128, ${ gradientOpacity }))`;

    if(percentage >= 100) {
      this.shippingIndicator.style.color = '#FFFFFF';
      const containerWidth = this.shippingIndicator.getBoundingClientRect().width;
      this.updateIndicator(percentage, containerWidth);
    } else {
      this.shippingIndicator.style.color = '#3C4755';
      this.shippingIndicator.style.backgroundColor = '#EBEBEB';
    }
  }

  interpolateColor(color1, color2, ratio) {
    const hexToRgb = (color) => {
      const rgba = color.match(/\d+/g).map(Number);
      return rgba.length === 3 ? rgba : rgba.slice(0, 3);
    };

    const rgb1 = hexToRgb(color1);
    const rgb2 = hexToRgb(color2);

    const r = Math.round(rgb1[0] + (rgb2[0] - rgb1[0]) * ratio);
    const g = Math.round(rgb1[1] + (rgb2[1] - rgb1[1]) * ratio);
    const b = Math.round(rgb1[2] + (rgb2[2] - rgb1[2]) * ratio);

    return `rgb(${r}, ${g}, ${b})`;
  }

  updateIndicator(progress, containerWidth) {
    const startColor = "rgb(255, 106, 106)";
    const endColor = "rgb(255, 179, 128)";
    const position = Math.min(progress / 100 * containerWidth, containerWidth);
    const ratio = position / containerWidth;
    const color = this.interpolateColor(startColor, endColor, ratio);

    this.shippingIndicator.style.backgroundColor = color;
  }

  async checkSubscription() {
    const req = await fetch('/cart.js');
    const cart = await req.json();
    const atLeastOneSubscription = cart.items.some(item => item?.selling_plan_allocation && item?.selling_plan_allocation?.selling_plan);

    return atLeastOneSubscription;
  }
}

customElements.define('shipping-bar', ShippingBar);